import * as Yup from "yup";

export default function validationSchema() {
  return Yup.object({
    attachLabels: Yup.array(),
    removeLabels: Yup.array()
  });
}